/*
 * Pure helpers for the inbox realtime layer. NO firebase / Preact imports, so
 * these are unit-testable in isolation (the firebase wiring lives in
 * inboxRealtime.js and uses these).
 */

// Stable, order-independent id for the 1:1 conversation between two uuids.
export function conversationId(a, b) {
    return [String(a), String(b)].sort().join('__');
}

// Given a typing doc { user, name, atMs }, return the display name to show, or
// null. Suppresses my own typing and anything older than windowMs.
export function isTypingActive(typingData, myUuid, nowMs, windowMs = 5000) {
    if (!typingData || !typingData.user || typingData.user === myUuid) {
        return null;
    }
    if (typeof typingData.atMs !== 'number') {
        return null;
    }
    if (nowMs - typingData.atMs > windowMs) {
        return null;
    }
    return typingData.name || ' ';
}

// Throttle gate for typing writes: true on first send and once per intervalMs.
export function shouldSendTyping(lastSentMs, nowMs, intervalMs = 3000) {
    return !lastSentMs || (nowMs - lastSentMs) >= intervalMs;
}
